





























import { Component } from 'vue-property-decorator';
import { WebhooksModule } from '@/store/Settings/WebhooksModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import WebhookDetails from '@/components/Settings/Webhooks/WebhookDetails.vue';

@Component({ name: 'Webhook', components: { Alert, WebhookDetails }, metaInfo: { title: 'Webhooks' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await WebhooksModule.getWebhook(this.$route.params.id);
    }

    get webhook() {
        return WebhooksModule.webhook;
    }

    get loading() {
        return WebhooksModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
